"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.users = exports.searchDropdownToggled = exports.searchResults = exports.searchString = exports.initialState = exports.iState = void 0;
const t = require("io-ts");
const ActionTypes = require("../actionTypes/users");
const TypesLib = require("@caddigital/sok-types");
const monocle = require("monocle-ts");
exports.iState = t.interface({
    searchString: t.string,
    searchResults: t.array(TypesLib.User.iUser),
    searchDropdownToggled: t.boolean
});
exports.initialState = {
    searchString: '',
    searchResults: [],
    searchDropdownToggled: false
};
exports.searchString = monocle.Lens.fromProp('searchString');
exports.searchResults = monocle.Lens.fromProp('searchResults');
exports.searchDropdownToggled = monocle.Lens.fromProp('searchDropdownToggled');
const users = (state = exports.initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_SEARCH_STRING:
            return exports.searchString.set(action.searchString)(state);
        case ActionTypes.SEARCH_USERS_SUCCESS:
            return exports.searchResults.set(action.data)(state);
        case ActionTypes.TOGGLE_SEARCH_DROPDOWN:
            return exports.searchDropdownToggled.set(action.flag)(state);
        default:
            return state;
    }
};
exports.users = users;
//# sourceMappingURL=users.js.map